var moduleMap = {
	"./constants": function() {
		return Promise.all([__webpack_require__.e(77113), __webpack_require__.e(9145), __webpack_require__.e(41805), __webpack_require__.e(48174), __webpack_require__.e(35866), __webpack_require__.e(34254), __webpack_require__.e(99581)]).then(function() { return function() { return (__webpack_require__("../microfrontends/exposed-modules/constants.ts")); }; });
	},
	"./i18n": function() {
		return Promise.all([__webpack_require__.e(31079), __webpack_require__.e(12576), __webpack_require__.e(88393), __webpack_require__.e(46847)]).then(function() { return function() { return (__webpack_require__("../microfrontends/exposed-modules/i18n.ts")); }; });
	},
	"./redux/actions": function() {
		return Promise.all([__webpack_require__.e(13220), __webpack_require__.e(78050), __webpack_require__.e(447)]).then(function() { return function() { return (__webpack_require__("../microfrontends/exposed-modules/reduxActions.ts")); }; });
	},
	"./redux/selectors": function() {
		return Promise.all([__webpack_require__.e(31079), __webpack_require__.e(12576), __webpack_require__.e(13220), __webpack_require__.e(96869), __webpack_require__.e(93072)]).then(function() { return function() { return (__webpack_require__("../microfrontends/exposed-modules/reduxSelectors.ts")); }; });
	},
	"./utils": function() {
		return Promise.all([__webpack_require__.e(77113), __webpack_require__.e(9145), __webpack_require__.e(41805), __webpack_require__.e(48174), __webpack_require__.e(35866), __webpack_require__.e(78050), __webpack_require__.e(34254), __webpack_require__.e(48479)]).then(function() { return function() { return (__webpack_require__("../microfrontends/exposed-modules/utils.ts")); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});